import { Tag as AntTag } from 'antd';
import React, { memo } from 'react';

import { DataOperationStatus } from 'types/models/data-operation';

/** Maps from DataOperationStatus to Ant Design tag color */
const DATA_OPERATION_STATUS_TO_ANT_TAG_COLOR: Record<DataOperationStatus, string> = {
  [DataOperationStatus.PENDING]: 'blue',
  [DataOperationStatus.IN_PROGRESS]: 'processing',
  [DataOperationStatus.COMPLETED]: 'success',
  [DataOperationStatus.FAILED]: 'error',
  [DataOperationStatus.RESTORING]: 'warning',
  [DataOperationStatus.RESTORED]: 'default'
};

type BackOfficeDataOperationStatusTagProps = {
  status: DataOperationStatus;
};

function BackOfficeDataOperationStatusTag({
  status
}: BackOfficeDataOperationStatusTagProps): JSX.Element {
  return (
    <AntTag className="BackOfficeDataOperationStatusTag" color={DATA_OPERATION_STATUS_TO_ANT_TAG_COLOR[status]}>
      {status.toUpperCase()}
    </AntTag>
  );
}

export default memo(BackOfficeDataOperationStatusTag);
export type { BackOfficeDataOperationStatusTagProps };
